import React, { Component, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Collapse, Container, Image, Nav, Navbar, NavDropdown, NavbarBrand, NavItem, NavLink } from 'react-bootstrap';
import { useState } from 'react';
import { AuthContext } from "../../AuthContext";
import "../gdacs_2.0.css";

const NavUser = (props) => {
    const authContext = useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const history = useHistory();

    const handleLogout = () => {
        localStorage.removeItem();
        authContext.logout();
    }

    useEffect(() => {
        setIsAuthenticated(props.isAuthenticated);
    }, [props])

    return (
        <header id="gdacs_header" className="container_page">
            <Navbar collapseOnSelect expand="lg" bg="#9bc1ce" variant="dark" color="#9bc1ce">
                <Container>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" >
                        <span className="navbar-toggler-icon" style={{ color: 'white', fontSize: '16px' }}></span>&nbsp;
                      MENU
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav>
                            <Nav.Link className="nav-item nav-link-gdacs" href="/default.aspx" target="_blank">HOME<span className="sr-only">(current)</span></Nav.Link>
                            <Nav.Link className="nav-item nav-link-gdacs" href="/Alerts/default.aspx" target="_blank">ALERTS</Nav.Link>
                            <Nav.Link className="nav-item nav-link-gdacs" href="http://vosocc.unocha.org" target="_blank">VIRTUAL OSOCC</Nav.Link>
                            <Nav.Link className="nav-item nav-link-gdacs" href="/Satellite/overview.aspx" target="_blank">MAPS &amp; SATELLITE IMAGERY</Nav.Link>
                            <Nav.Link className="nav-item nav-link-gdacs" href="/Knowledge/overview.aspx" target="_blank">KNOWLEDGE</Nav.Link>
                            <Nav.Link className="nav-item nav-link-gdacs" href="/About/overview.aspx" target="_blank">ABOUT</Nav.Link>
                            {authContext.isLoggedIn === undefined &&
                                <Nav.Link className="nav-item nav-link-gdacs" href="/gdacsregister/" onClick={handleLogout}>
                                    LOGOUT
                            </Nav.Link>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}
export { NavUser }